/*
 * Copyright (c) 2019
 *    Author: Ronnel Bedana - ronnelbedana2011@gmail.com
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */


import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { RestResponse } from '../models/api.io';
import { ApiHeaders } from '../models/headers';

export const environment = {
  production: false,
  API_URL: 'https://shell.us-east-1.elasticbeanstalk.com'
};

@Injectable()
export class LibOrderProvider {

  constructor(
    private http: HttpClient
  ) { }

  getOrder(id: string): Observable<RestResponse> {
    return this.http.get<RestResponse>(environment.API_URL + `/api/order/${id}`, ApiHeaders.getOptions());
  }
}
